import React from 'react';
import { cn } from '@/lib/twUtils';

const sizes = {
  /** Sottotitolo di hero */
  lead: 'text-[clamp(1.03125rem,2vw,1.21875rem)] leading-[1.6]',
  /** Introduzione di sezione */
  intro: 'text-[1.03125rem] leading-[1.62]',
  /** Corpo delle card */
  body: 'text-[0.9375rem] leading-[1.62]',
  /** Testo minore, didascalie */
  small: 'text-[0.875rem] leading-[1.6]',
  /** Note a piè di blocco */
  note: 'text-[0.8125rem] leading-[1.6]',
} as const;

const tones = {
  muted: 'text-ink-muted',
  strong: 'text-ink-strong',
  subtle: 'text-ink-subtle',
  onDark: 'text-white/70',
  onDarkSubtle: 'text-white/50',
} as const;

export interface TextProps extends React.HTMLAttributes<HTMLParagraphElement> {
  size?: keyof typeof sizes;
  tone?: keyof typeof tones;
  as?: React.ElementType;
}

/** Paragrafo del design system. */
const Text = ({ size = 'body', tone = 'muted', as: Tag = 'p', className, ...props }: TextProps) => (
  <Tag className={cn('text-pretty', sizes[size], tones[tone], className)} {...props} />
);

export default Text;
